<template>
    <div class="form-group">
      <!-- Label acima do switch -->
      <label v-if="label" :for="id" class="form-label" v-safe-html="label"></label>
  
      <!-- Switch e texto "Sim" ou "Não" lado a lado -->
      <div class="d-flex align-items-center mt-1">
        <div class="form-check form-switch me-2">
          <input
            class="form-check-input"
            type="checkbox"
            :id="id"
            :checked="modelValue"
            @change="$emit('update:modelValue', $event.target.checked)"
          />
        </div>
        <span class="small">{{ modelValue ? 'Sim' : 'Não' }}</span>
    </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'SwitchField',
    props: {
      modelValue: {
        type: Boolean,
        default: false
      },
      label: {
        type: String,
        default: ''
      },
      id: {
        type: String,
        default: null
      }
    }
  };
  </script>

<style>

.small {

    font-size: 10px;
}

</style>